import AppHeader from "./AppHeader";
import { connect } from "react-redux";
import { AppConfig } from "../config";
import { LANGUAGE } from "../constant/language";
import { APPPERM, APPCATEGORY } from "../constant/appconst";
import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { history } from "../history";
import moment from "moment/moment";
import { moveTo, getVersion, formatBytes } from "../lib/function";
import { useParams } from "react-router-dom";

const App = ({ appInfo }) => {
    AWS.config.update({ region: 'ap-northeast-2', accessKeyId: AppConfig.DYNAMO_DB_ACCESS_KEY, secretAccessKey: AppConfig.DYNAMO_DB_SECRET_KEY });
    const [lang, setLang] = useState('');
    const [imageSeq, setImageSeq] = useState(0);
    const [faqSeq, setFaqSeq] = useState(0);
    const [showDownload, setShowDownload] = useState({ install: false, manual: false });

    const { t, i18n } = useTranslation(['translation']);

    useEffect(() => {
        const install = appInfo?.appDownloadInfo?.hasOwnProperty('url') ? true : false;
        const manual = (!appInfo?.manualDownloadInfo || appInfo?.manualDownloadInfo.length === 0) ? false : true;
        setShowDownload({ install, manual });
    }, [appInfo?.appDownloadInfo, appInfo?.manualDownloadInfo]);

    useEffect(() => {
        setLang(i18n.language);
    }, [i18n.language]);

    const rLang = (langs) => {
        const r = [];
        {langs?.map(x => {
            var ln = LANGUAGE.find(l => l.code === x)
            r.push(ln.label || x)
        })}
        return r.join(", ");
    }

    console.log(appInfo);

    return (
        <>
            <AppHeader />
            <section
                className="wrapper image-wrapper bg-overlay bg-overlay-400 bg-content app-bg-violet bg-position-top"
                data-image-src={appInfo?.bgImage}
                style={{ backgroundImage: `url("${appInfo?.bgImage}")` }}>
                <div className="container py-16 py-md-13 pb-10 app-page">
                    <div className="row pt-md-12">
                        <div className="col-lg-7 z-index-9">
                            <img src={appInfo?.appIcon} className="app-img-mobile" />
                            <h2 className="display-4 mb-3">{appInfo?.appTitle}</h2>
                            <div className="fs-lg mb-6" dangerouslySetInnerHTML={{ __html: appInfo?.description?.replace(/<p/g,'<p className="mb-0 opacity-75"') }}></div>
                            <div className="row gy-3 gx-xl-8">
                                <div className="col-xl-6">
                                    <ul className="icon-list bullet-bg bullet-primary mb-0">
                                        <li><span><i className="uil uil-check"></i></span><span className="opacity-90">{t('제공자')}: {appInfo?.provider}</span></li>
                                        <li className="mt-3"><span><i className="uil uil-check"></i></span><span className="opacity-90">{t('카테고리')}: {APPCATEGORY.find(x => x.value === appInfo?.category)?.label || appInfo.category}</span></li>
                                    </ul>
                                </div>
                                <div className="col-lg-5">
                                    <ul className="icon-list bullet-bg bullet-primary mb-0">
                                        <li><span><i className="uil uil-check"></i></span><span className="opacity-90">{t('업데이트')}: {appInfo?.updated && moment(appInfo?.updated).format('YYYY. MM. DD')}</span></li>
                                        <li className="mt-3"><span><i className="uil uil-check"></i></span><span className="opacity-90">{t('크기')}: {appInfo?.fileSize}</span></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5 app-image text-center">
                            <img src={appInfo?.appIcon} className="app-img-original" />
                            <img src={appInfo?.appIcon} className="app-img-blur" />
                        </div>
                    </div>
                </div>
            </section>
            <section className="wrapper mt-10 mb-md-14 mb-0 app-page">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-8 app-main-info">
                            {appInfo?.screenshot?.length > 0 && <div className="mb-8">
                                <h5>{t('스크린샷')}</h5>
                                <div className="basic-slider owl-carousel dots-over owl-loaded owl-drag" data-nav="true" data-margin="5">
                                    <div className="owl-stage-outer owl-height" style={{ height: ' 538px' }}>
                                        <div className="owl-stage"
                                            style={{
                                                transform: 'translate3d(0px, 0px, 0px)',
                                                transition: 'all 0.5s ease 0s',
                                                width: '1540px',
                                            }}>
                                            <div className="owl-item active" style={{ width: '825px', marginRight: '5px' }}>
                                                <div className="item"><img src={appInfo?.screenshot?.find(x => x.seq === imageSeq)?.url} className="rounded" alt="" /></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="owl-nav">
                                        <button type="button" role="presentation" className="owl-prev"
                                            onClick={() => {
                                                if (imageSeq > 0)
                                                    setImageSeq(imageSeq - 1)
                                            }}>
                                            <i className="uil-arrow-left"></i>
                                        </button>

                                        <button type="button" role="presentation" className="owl-next" onClick={() => {
                                            if (imageSeq < screenshot.length - 1)
                                                setImageSeq(imageSeq + 1)
                                        }}>
                                            <i className="uil-arrow-right"></i>
                                        </button>
                                    </div>
                                    <div className="owl-dots">
                                        {
                                            appInfo?.screenshot?.map((x, idx) => {
                                                return <button
                                                    key={'app_info_' + idx}
                                                    role="button"
                                                    className={"owl-dot" + (idx === imageSeq ? ' active' : '')}
                                                    onClick={() => setImageSeq(idx)}><span></span></button>
                                            })
                                        }
                                    </div>
                                </div>
                            </div>}
                            {appInfo?.intro && <div className="mb-8">
                                <h5>{t('앱 정보')}</h5>
                                <div dangerouslySetInnerHTML={{ __html: appInfo?.intro }}></div>
                            </div>}
                            {appInfo?.movie?.length > 0 && <div className="mb-8">
                                <h5>{t('미디어')}</h5>
                                <div className="row">
                                    <div className="col-lg-12">
                                        {
                                            appInfo?.movie?.map((x, idx) => {
                                                return (
                                                    <div key={'movie_' + idx}>
                                                        <div>
                                                            <iframe width="100%" height="400" src={x.url.replace("https://www.youtube.com/watch?v=", "https://youtu.be/").replace('https://youtu.be', 'https://www.youtube.com/embed')} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                    <div className="col-12">
                                        {/* <p><a href="#" className="underline">더 보기</a></p> */}
                                    </div>
                                </div>
                            </div>}
                            {appInfo?.feature?.length > 0 && <div className="mb-8">
                                <h5>{t('주요 기능')}</h5>
                                <div className="row">
                                    <div className="col-lg-12">
                                        {
                                            appInfo?.feature?.map((x, idx) => {
                                                return (
                                                    <div key={'feature_' + idx}>
                                                        <h3>{x.title}</h3>
                                                        <div dangerouslySetInnerHTML={{ __html: x.contents }}></div>
                                                        <div>
                                                            {x.mediaType === 'image' && <img src={x.mediaLink} />}
                                                            {x.mediaType === 'movie' && <iframe width="100%" height="400" src={x.mediaLink.replace('https://youtu.be', 'https://www.youtube.com/embed')} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>}
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                    <div className="col-12">
                                        {/* <p><a href="#" className="underline">더 보기</a></p> */}
                                    </div>
                                </div>
                            </div>}
                            <div className="mb-8">
                                <h5>{t('권한')}</h5>
                                <div className="row">

                                    <div className="col-lg-6">
                                        {appInfo?.appAuth?.length > 0 && <ul className="icon-list bullet-bg bullet mb-0">
                                            {
                                                appInfo?.appAuth?.map((x, idx) => <li key={'app_auth_' + idx}><span><i className="uil uil-check"></i></span><span>{APPPERM.find(y => y.code === x).label}</span></li>)
                                            }
                                        </ul>}
                                        {appInfo?.appAuth?.length === 0 && <p>{t("No permissions required")}</p>}
                                    </div>
                                    <div className="col-12">
                                        {/* <p className="mt-4"><a href="#" className="underline">더 보기</a></p> */}
                                    </div>
                                </div>
                            </div>
                            {appInfo?.faq?.length > 0 && <div className="mb-8">
                                <h5>{t('자주 찾는 질문')}</h5>
                                <div className="accordion accordion-wrapper mt-4" id="accordionExample-2">
                                    {
                                        appInfo?.faq?.map((x, idx) => {
                                            return (
                                                <div key={'faq_' + idx} className="card plain accordion-item">
                                                    <div className="card-header" id="headingOne-2">
                                                        <button className="collapsed" data-bs-toggle="collapse" data-bs-target="#collapseOne-2" aria-expanded="false" aria-controls="collapseOne-2" onClick={() => setFaqSeq(idx)}>
                                                            {x.q}
                                                        </button>
                                                    </div>
                                                    <div id="collapseOne-2" className={"accordion-collapse collapse" + (faqSeq === idx ? ' show' : '')} aria-labelledby="headingOne-2" data-bs-parent="#accordionExample-2">
                                                        <div className="card-body" dangerouslySetInnerHTML={{ __html: x.a }}></div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>}
                        </div>
                        <div className="col-xl-4 app-side-bar">
                            <div className="accordion accordion-wrapper mt-md-3" id="accordionSimpleExample">
                                {
                                    (showDownload?.install || showDownload?.manual) &&
                                    (
                                        <div className="card plain accordion-item">
                                            <div id="divDownload" className="accordion-collapse collapse show" aria-labelledby="divDownload" data-bs-parent="#accordionSimpleExample">
                                                <div className="card-body">
                                                    {
                                                        showDownload?.install &&
                                                        <p>
                                                            <a href={appInfo?.appDownloadInfo.url} className="btn btn-md btn-primary rounded-pill text-white w-21 text-decoration-none">{t('다운로드')}</a>
                                                        </p>
                                                    }
                                                    <ul>
                                                        {
                                                            showDownload?.install &&
                                                            (
                                                                <li>
                                                                    <p className="fs-14">
                                                                        <i className="uil uil-info-circle"></i> {t('버전')} : {appInfo?.appDownloadInfo.version} <br />
                                                                        <i className="uil uil-info-circle"></i> {t('크기')} : {formatBytes(appInfo?.appDownloadInfo.fileSize)}<br />
                                                                        <i className="uil uil-info-circle"></i> {t('업데이트 날짜')} : {moment(appInfo?.appDownloadInfo.updated).format('YYYY. MM. DD')}</p>
                                                                    
                                                                </li>
                                                            )
                                                        }
                                                        {
                                                            showDownload.manual && (
                                                                <li>
                                                                    <p className="mt-2 mb-1 text-dark mb-2"><strong>{t('매뉴얼')}</strong></p>
                                                                    {/* <p className="fs-14">
                                                                        <i className="uil uil-info-circle"></i> {t('버전')} : 2.1.5.1 <br />
                                                                        <i className="uil uil-info-circle"></i> {t('크기')} : 3.75 MB<br />
                                                                        <i className="uil uil-info-circle"></i> {t('업데이트 날짜')}: 2023-03-06</p> */}
                                                                    <p>
                                                                        {
                                                                            appInfo?.manualDownloadInfo?.map((x, idx) => {
                                                                                return (
                                                                                    <a key={`manual_${idx}`} href={x.url} className="btn btn-md btn-dark rounded-pill text-white w-21 text-decoration-none mb-2">
                                                                                        {x.title}
                                                                                    </a>
                                                                                )
                                                                            })
                                                                        }
                                                                    </p>
                                                                </li>
                                                            )
                                                        }
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                                
                                <div className="card plain accordion-item">
                                    <div className="card-header" id="headingSimpleOne">
                                        <button className="accordion-button" data-bs-toggle="collapse" data-bs-target="#collapseSimpleOne" aria-expanded="true" aria-controls="collapseSimpleOne"> {t('최신 버전')}</button>
                                    </div>
                                    <div id="collapseSimpleOne" className="accordion-collapse collapse show" aria-labelledby="headingSimpleOne" data-bs-parent="#accordionSimpleExample">
                                        <div className="card-body">
                                            <ul>
                                                <li>
                                                    <p><a href='#' onClick={(e) => moveTo(history, e, location.pathname + '/releasenotes')}>{getVersion(appInfo?.version)}</a></p>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="card plain accordion-item">
                                    <div className="card-header" id="headingSimpleOne">
                                        <button className="accordion-button" data-bs-toggle="collapse" data-bs-target="#collapseSimpleOne" aria-expanded="true" aria-controls="collapseSimpleOne"> {t('제공자 정보')}</button>
                                    </div>
                                    <div id="collapseSimpleOne" className="accordion-collapse collapse show" aria-labelledby="headingSimpleOne" data-bs-parent="#accordionSimpleExample">
                                        <div className="card-body">
                                            <ul>
                                                <li>
                                                    <p className="mb-0"><i className="uil uil-globe"></i> {t('웹 사이트')}</p>
                                                    <p><a href={appInfo?.providerLink} target="_blank">{appInfo?.providerLink}</a></p>
                                                </li>
                                                <li>
                                                    <p className="mb-0"><i className="uil uil-shield-check"></i> {t('개인정보 처리방침')}</p>
                                                    <p><a href={appInfo?.privacyLink} target="_blank">{appInfo?.privacyLink}</a></p>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="card plain accordion-item">
                                    <div className="card-header" id="headingSimpleTwo">
                                        <button className="collapsed" data-bs-toggle="collapse" data-bs-target="#collapseSimpleTwo" aria-expanded="false" aria-controls="collapseSimpleTwo"> {t('지원 언어')}</button>
                                    </div>
                                    <div id="collapseSimpleTwo" className="accordion-collapse collapse show" aria-labelledby="headingSimpleTwo" data-bs-parent="#accordionSimpleExample">
                                        <div className="card-body">
                                            <p>
                                                {rLang(appInfo?.languages)}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="card plain accordion-item">
                                    <div className="card-header" id="headingSimpleThree">
                                        <button className="collapsed" data-bs-toggle="collapse" data-bs-target="#collapseSimpleThree" aria-expanded="false" aria-controls="collapseSimpleThree"> {t('태그')}</button>
                                    </div>
                                    <div id="collapseSimpleThree" className="accordion-collapse collapse show" aria-labelledby="headingSimpleThree" data-bs-parent="#accordionSimpleExample">
                                        <div className="card-body">
                                            <p>
                                                {appInfo?.tags?.map((x, idx) => <span key={'tags_' + idx} className="badge bg-primary rounded-pill">{x.tag}</span>)}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

const mapState = (state) => {
    const appInfo = state.AppReducer.appInfo;
    return { appInfo };
}

export default connect(mapState, null)(App);
